module.exports = __webpack_public_path__ + "img/color-logo.552edba1.svg";